export default __webpack_public_path__ + "static/Icons-29149f0e7958a212b9a167909f8072cd.svg";